'use strict';

require('./chunk-d7703e54.js');
require('./variadic.js');
var __chunk_4 = require('./chunk-e6d921c6.js');
var head = require('./head.js');
var tail = require('./tail.js');
var copy = require('./copy.js');
var __chunk_6 = require('./chunk-fac2c876.js');

function set_(ks, v, o) {
  var k = head(ks);

  if (ks.length > 1) {
    v = set_(tail(ks), v, o[k] || {});
  }

  return copy(o, __chunk_6._defineProperty({}, k, v));
}

function set(ks, v, o) {
  ks = __chunk_4.isArray(ks) ? ks : ks.toString().split('.');
  return set_(ks, v, o);
}

module.exports = set;
